import "../tui-modal";
import "../tui-tooltip";
import "../collection-switcher";
import "../header-menus";
import { initDeploymentOutputCopy } from "../components/deployment-output-copy";

// The deployment log popover (and its "Copy output") shows up on the agent page, both deployment
// edit pages and the run history page, so its one delegated click handler lives here.
initDeploymentOutputCopy();

// The server reads these to show times in the user's zone and clock (UserTimeExtensions.cs). Written on
// every page, the login page included, so they're in place before the first authenticated render.
function writeTimeCookies(): void {
    const maxAge = "; path=/; max-age=31536000; SameSite=Lax";
    const format = new Intl.DateTimeFormat(undefined, { hour: "numeric" }).resolvedOptions();
    document.cookie = "certkit_time_zone=" + encodeURIComponent(format.timeZone) + maxAge;
    document.cookie = "certkit_clock=" + (format.hour12 ? "12" : "24") + maxAge;
}

writeTimeCookies();

function getEffectiveTheme(): "light" | "dark" {
    const stored = localStorage.getItem("theme");
    if (stored === "dark" || stored === "light") {
        return stored;
    }
    if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) {
        return "dark";
    }
    return "light";
}

function setTheme(theme: "light" | "dark"): void {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
    updateToggleButtons(theme);

    const meta = document.querySelector('meta[name="color-scheme"]');
    if (meta) {
        meta.setAttribute("content", theme);
    }
}

function updateToggleButtons(theme: string): void {
    const toggles = document.querySelectorAll<HTMLElement>("[data-theme-toggle]");
    toggles.forEach((toggle) => {
        const icon = toggle.querySelector("[data-theme-icon]") as HTMLElement;
        const link = toggle.querySelector("a") as HTMLElement;
        if (!icon || !link) return;
        if (theme === "dark") {
            icon.textContent = "\u2600\uFE0F";
            link.textContent = "Toggle Light Mode";
        } else {
            icon.textContent = "\uD83C\uDF19";
            link.textContent = "Toggle Dark Mode";
        }
    });
}

function handleToggle(): void {
    const current = getEffectiveTheme();
    const next = current === "dark" ? "light" : "dark";
    setTheme(next);
}

document.addEventListener("DOMContentLoaded", () => {
    updateToggleButtons(getEffectiveTheme());

    const toggles = document.querySelectorAll("[data-theme-toggle]");
    toggles.forEach((toggle) => {
        toggle.addEventListener("click", (e) => {
            e.preventDefault();
            handleToggle();
        });
    });

    if (window.matchMedia) {
        window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", () => {
            if (!localStorage.getItem("theme")) {
                updateToggleButtons(getEffectiveTheme());
            }
        });
    }
});
